import React, { useEffect, useState } from "react";
import PageTableHeader from "../../../../components/pageTableHeader/pageTableHeader";

import toast from "react-hot-toast";

import { useParams } from "react-router-dom";
import { getHelpCenterQuestionDetail } from "../../../../../services/workspace/helpCenterQuestion.service";
import HelpCenterSearch from "../../components/helpCenterSearch";

function QuestionDetailPage() {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const items = [
    { label: "Home", path: "/" },
    { label: "Help Center", path: "/help" },

    { label: "Detail", path: "" },
  ];
  useEffect(() => {
    setLoading(true);
    getHelpCenterQuestionDetail(id)
      .then((response) => {
        setData(response);
      })
      .catch((error) => {
        toast.error("Failed to fetch the category data!");
        console.error("Error fetching data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  return (
    <div className="flex flex-col gap-2">
      <PageTableHeader
        breadcrumbs={items}
        isSearch={false}
        isFilter={false}
        buttons={false}
      />
      <div className="flex flex-col gap-4 bg-white p-4 text-theme h-[calc(100vh-160px)]">
        <HelpCenterSearch />

        <div className="overflow-y-auto">
          {loading ? (
            <Loading />
          ) : (
            data && (
              <div>
                <h2 className="text-theme font-bold text-md ">
                  Q. {data.question}
                </h2>
                <p className="text-textLight text-md"> {data.answer}</p>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
}

const Loading = () => {
  return (
    <div className="flex flex-col gap-2">
      <div className="animate-pulse space-y-2 border-b py-3">
        <div className="h-6 bg-bghoverlight rounded w-2/3"></div>
        <div className="h-4 bg-bghoverlight rounded w-full"></div>
        <div className="h-4 bg-bghoverlight rounded w-2/4"></div>
      </div>
      <div className="animate-pulse space-y-2 border-b py-3">
        <div className="h-6 bg-bghoverlight rounded w-2/3"></div>
        <div className="h-4 bg-bghoverlight rounded w-full"></div>
      </div>
      <div className="animate-pulse space-y-2 py-3">
        <div className="h-6 bg-bghoverlight rounded w-3/4"></div>
        <div className="h-4 bg-bghoverlight rounded w-full"></div>
        <div className="h-4 bg-bghoverlight rounded w-full"></div>
      </div>
    </div>
  );
};
export default QuestionDetailPage;
